export default __webpack_public_path__ + "static/media/weather_light_mode.bb24c03d.svg";